module.exports = __webpack_public_path__ + "img/mirror08.60d6c97c.jpg";